import AndroidOutlined from '@ant-design/icons/AndroidOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import { t } from 'i18n';

const content = {
  id: 'group-content',
  title: t('Content'),
  type: 'group',
  children: [
    { id: 'contents', title: t('Contents'), type: 'item', url: '/content/pages', icon: FileTextOutlined },
    { id: 'app-downloads', title: t('App Downloads'), type: 'item', url: '/content/app-downloads', icon: AndroidOutlined }
  ]
};

export default content;
